import { Box } from '@mui/system'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import LoginBackSvg from '../../../images/loginBackSvg.svg'
import FirstTimePasswordImage from '../../../images/firstTimePassword.svg'
import ResponsiveAppBar from '../../../components/ResponsiveAppBar'
import Form from './Form'
import Success from './Success'
import CookiesStorageService from '../../../services/CookiesStorageService'
import AppRoutes from '../../../services/AppRoutes'

const FirstTimePassword = () => {
  const [changePasswordSuccess, setChangePasswordSuccess] = useState(false)
  const history = useHistory()

  useEffect(() => {
    const isFirstLogin = CookiesStorageService.getIsFirstLogin();
    if (!isFirstLogin) {
      history.push(AppRoutes.home);
    }
  }, []);

  return (
    <Box sx={styles.root}>
      <ResponsiveAppBar />

      <Box sx={styles.loginContainer}>
        {
          changePasswordSuccess ? (<Success/>)
            : (<Form setChangePasswordSuccess={setChangePasswordSuccess}/>)
        }

        <Box sx={styles.rightImage}>
          <img src={FirstTimePasswordImage} alt='login img' />
        </Box>
        <Box sx={styles.backSvg}>
          <img src={LoginBackSvg} alt='login img' />
        </Box>
      </Box>

    </Box>
  )
}
const styles = {
  root: {
    '& header': {
      marginBottom: '0px',
    },
  },
  loginContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: { xs: 'column-reverse', sm: 'row' },
    position: 'relative',
    minHeight: { xs: '70vh', sm: '90vh' },
    my: { xs: '10px', sm: '30px' },
  },

  backSvg: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 0,
    minHeight: '100vh',
    width: '100%',
  },

  rightImage: {
    position: 'relative',
    zIndex: '8',
    my: { xs: '10%', md: 'unset' },
    display: { xs: 'none', sm: 'block' },
    '& img': {
      width: { xs: '100%', sm: '300px', md: '600px' },
      height: { xs: '200px', sm: '100%', md: '600px' },
      mt: '20px',
    },
  },
}

export default FirstTimePassword
